<div class="single-dealer layout-spacing">
    @if (!dealerPageLoading() || dealerHydration().userId) {
        <header class="single-dealer__header">
            <div class="single-dealer__header-content">
                <div class="single-dealer__profile">
                    <div class="single-dealer__avatar">
                        <div class="single-dealer__avatar-container">
                            @if (dealerProfilePictureUrl(); as photoUrl) {
                                @if (!headerAvatarImageFailed()) {
                                    <img
                                        class="single-dealer__avatar-img"
                                        [src]="photoUrl"
                                        [alt]="dealerAvatarAlt()"
                                        width="125"
                                        height="125"
                                        loading="lazy"
                                        decoding="async"
                                        (error)="onHeaderAvatarImageError()" />
                                }
                            }
                            @if (!dealerProfilePictureUrl() || headerAvatarImageFailed()) {
                                <svg
                                    class="single-dealer__avatar-placeholder"
                                    aria-hidden="true"
                                    viewBox="0 0 512 512">
                                    <use
                                        [attr.href]="
                                            spritePath + '#' + icons['profilePlaceholder']
                                        "></use>
                                </svg>
                            }
                        </div>
                    </div>

                    <div class="single-dealer__info">
                        <div class="single-dealer__info-title">
                            <h1 class="single-dealer__info-business">{{ headerBusinessName() }}</h1>
                            @if (headerDealerDisplayName()) {
                                <span class="single-dealer__info-separator" aria-hidden="true"
                                    >·</span
                                >
                                <span class="single-dealer__info-name">{{
                                    headerDealerDisplayName()
                                }}</span>
                            }
                        </div>

                        @if (headerAlias()) {
                            <div class="single-dealer__info-alias">{{ headerAlias() }}</div>
                        }

                        @if (headerLocation()) {
                            <div class="single-dealer__info-location">
                                <svg width="14" height="14" class="single-dealer__info-icon">
                                    <use [attr.href]="spritePath + '#' + icons['mapFolded']"></use>
                                </svg>
                                {{ headerLocation() }}
                            </div>
                        }
                    </div>
                </div>

                <div class="single-dealer__meta" aria-label="Dealer contact information">
                    @if (dealerHeaderEmail()) {
                        <div class="single-dealer__meta-card">
                            <div class="single-dealer__meta-header">
                                <span class="single-dealer__meta-icon" aria-hidden="true">
                                    <svg class="single-dealer__meta-svg">
                                        <use [attr.href]="spritePath + '#' + icons['mail']"></use>
                                    </svg>
                                </span>
                                <span class="single-dealer__meta-label">Email</span>
                            </div>
                            <a
                                class="single-dealer__meta-value single-dealer__meta-link"
                                [href]="'mailto:' + dealerHeaderEmail()">
                                {{ dealerHeaderEmail() }}
                            </a>
                        </div>
                    }
                    @if (dealerHeaderPhone()) {
                        <div class="single-dealer__meta-card">
                            <div class="single-dealer__meta-header">
                                <span class="single-dealer__meta-icon" aria-hidden="true">
                                    <svg
                                        class="single-dealer__meta-svg"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.75"
                                        stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path
                                            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.86.34 1.7.66 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.8.32 1.64.54 2.5.66A2 2 0 0 1 22 16.92z" />
                                    </svg>
                                </span>
                                <span class="single-dealer__meta-label">Phone</span>
                            </div>
                            <a
                                class="single-dealer__meta-value single-dealer__meta-link"
                                [href]="dealerHeaderTelHref()">
                                {{ dealerHeaderPhone() }}
                            </a>
                        </div>
                    }
                    <div class="single-dealer__meta-card single-dealer__meta-card--accent">
                        <div class="single-dealer__meta-header">
                            <span class="single-dealer__meta-icon" aria-hidden="true">
                                <svg class="single-dealer__meta-svg">
                                    <use [attr.href]="spritePath + '#' + icons['licenses']"></use>
                                </svg>
                            </span>
                            <span class="single-dealer__meta-label">{{ labels.LICENSES }}</span>
                        </div>
                        <span class="single-dealer__meta-value single-dealer__meta-value--stat">
                            {{ dealerLicenseCount() }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="single-dealer__actions">
                <ntv-button
                    color="custom"
                    customColor="#8dcb2c"
                    size="xl"
                    rounded="md"
                    (buttonClick)="openEditDealerModal()">
                    <div class="single-dealer__actions-inner">
                        <span>{{ labels.MODIFY }}</span>
                        <svg width="14" height="14">
                            <use [attr.href]="spritePath + '#' + icons['gear']"></use>
                        </svg>
                    </div>
                </ntv-button>
            </div>
        </header>
    }

    <section class="single-dealer__content">
        <app-table-toolbar
            [placeholder]="labels.SEARCH_PLACEHOLDER"
            [buttons]="toolbarButtons()"
            (searchValueChange)="onLicenseSearchChange($event)" />

        <div class="single-dealer__content-table main-table-container">
            <app-table
                [columns]="licenseColumns"
                [data]="licenseRows()"
                [tableTitle]="labels.LICENSES"
                [tableHeight]="'600px'"
                [hasCheckBox]="false"
                [showColumnSettings]="false"
                [loading]="dealerPageLoading() || (licensesLoading() && !licensesLoadingMore())"
                [loadingOverlay]="licensesLoadingMore()"
                [totalDataLength]="licenseTableTotalCount()"
                (cellClick)="onLicenseCellClick($event)"
                (actionClick)="onLicenseAction($event)"
                (showMoreRequested)="loadMoreLicenses()">
                <ng-template ntvTableCell="anydesk" let-row="row">
                    <div class="anydesk-cell">
                        @if (row.anydesk?.length) {
                            @for (item of row.anydesk; track item.label) {
                                <div class="anydesk-item">
                                    <span class="anydesk-item__label">{{ item.label }}:</span>
                                    <span class="anydesk-item__value">{{
                                        item.value ?? '--'
                                    }}</span>
                                    @if (item.value) {
                                        <button
                                            type="button"
                                            class="anydesk-item__copy"
                                            [appCopy]="item.value"
                                            title="Copy">
                                            <svg width="12" height="12">
                                                <use
                                                    [attr.href]="
                                                        spritePath + '#' + icons['copy']
                                                    "></use>
                                            </svg>
                                        </button>
                                    }
                                </div>
                            }
                        } @else {
                            <span class="text-slate-400">--</span>
                        }
                    </div>
                </ng-template>
            </app-table>
        </div>
    </section>
</div>

@if (showDealerSaveSuccessModal()) {
    <app-confirmation-modal
        [isVisible]="showDealerSaveSuccessModal()"
        type="success"
        [title]="labels.CHANGES_SAVED"
        [message]="dealerSaveSuccessMessage()"
        confirmText="OK"
        [showCancelButton]="false"
        (confirm)="dismissDealerSaveSuccessModal()"
        (modalClose)="dismissDealerSaveSuccessModal()">
    </app-confirmation-modal>
}

@if (showDealerDeleteSuccessModal()) {
    <app-confirmation-modal
        [isVisible]="showDealerDeleteSuccessModal()"
        size="small"
        type="success"
        [title]="labels.DEALER_DELETE_SUCCESS_TITLE"
        [message]="(headerBusinessName() || 'Dealer') + ' has been successfully deleted.'"
        confirmText="OK"
        [showCancelButton]="false"
        (confirm)="onDeleteSuccessConfirm()"
        (modalClose)="onDeleteSuccessConfirm()">
    </app-confirmation-modal>
}

@if (showLicenseDeleteConfirmModal()) {
    <app-confirmation-modal
        [isVisible]="showLicenseDeleteConfirmModal()"
        [showCancelButton]="true"
        size="small"
        type="warning"
        [title]="labels.LICENSE_DELETE_TITLE"
        [message]="
            'Are you sure you want to delete license ' +
            (licensePendingDelete()?.id ||
                licensePendingDelete()?.alias ||
                licensePendingDelete()?.licenseKey ||
                '') +
            '? This action cannot be undone.'
        "
        confirmText="Delete"
        cancelText="Cancel"
        [isLoading]="isLicenseDeleteInProgress()"
        (confirm)="onConfirmLicenseDelete()"
        (cancel)="closeLicenseDeleteConfirmModal()"
        (modalClose)="closeLicenseDeleteConfirmModal()">
    </app-confirmation-modal>
}

@if (showLicenseDeleteSuccessModal()) {
    <app-confirmation-modal
        [isVisible]="showLicenseDeleteSuccessModal()"
        size="small"
        type="success"
        [title]="labels.LICENSE_DELETE_SUCCESS_TITLE"
        [message]="labels.LICENSE_DELETE_SUCCESS_MESSAGE"
        confirmText="OK"
        [showCancelButton]="false"
        (confirm)="closeLicenseDeleteSuccessModal()"
        (modalClose)="closeLicenseDeleteSuccessModal()">
    </app-confirmation-modal>
}

<app-edit-dealer-modal
    [isVisible]="isEditDealerModalOpen()"
    [dealer]="dealerHydration()"
    [saveError]="saveError()"
    [isDeleting]="isDeletingDealer()"
    [resetPasswordDisabled]="resetPasswordDisabled()"
    [resetPasswordCooldownSeconds]="changePasswordSecondsLeft()"
    [resetPasswordTooltip]="changePasswordTooltip()"
    [showPasswordLimitReached]="showPasswordLimitModal()"
    [passwordLimitTitle]="passwordLimitTitle"
    [passwordLimitMessage]="passwordLimitMessage"
    [showPasswordResetSuccess]="showPasswordResetModal()"
    [passwordResetSuccessTitle]="labels.PASSWORD_RESET_SENT"
    [passwordResetSuccessMessage]="passwordResetMessage()"
    (modalClose)="closeEditDealerModal()"
    (update)="onDealerUpdate($event)"
    (cancel)="closeEditDealerModal()"
    (delete)="onDealerDelete()"
    (resetPassword)="onResetPasswordForDealer()"
    (passwordLimitDismiss)="closePasswordLimitModal()"
    (passwordResetSuccessDismiss)="closePasswordResetModal()">
</app-edit-dealer-modal>
